import map from 'lodash/fp/map'
import pick from 'lodash/fp/pick'
import getOr from 'lodash/fp/getOr'
import filter from 'lodash/fp/filter'
import compose from 'lodash/fp/compose'
import * as yup from 'yup'

export const getNewResponsibles = () => ({
  type: 1,
  name: '',
  experience: '',
  years_in: ''
})

export const getNewCollaborator = () => ({
  type: 2,
  name: '',
  how_participates: ''
})

const commonSchema = {
  name: yup.string().required()
}

const validationSchema = yup.object().shape({
  responsibles: yup
    .array()
    .of(yup.object().shape({
      ...commonSchema,
      experience: yup.number().min(0).required(),
      years_in: yup.number().min(0).required()
    })),
  collaborators: yup
    .array()
    .of(yup.object().shape({
      ...commonSchema,
      how_participates: yup.string().required()
    }))
})

const filterUndefined = filter(v => v)
const getApplyResponsibles = compose(
  map(pick(['name', 'experience', 'years_in', 'type'])),
  filter(c => c.type === 1),
  responsibles => !responsibles.length ? [getNewResponsibles()] : responsibles,
  filterUndefined,
  getOr([], 'people')
)
const getApplyCollaborators = compose(
  map(pick(['name', 'how_participates', 'type'])),
  filter(c => c.type === 2),
  filterUndefined,
  getOr([], 'people')
)
const mapPropsToValues = ({ application }) => ({
  responsibles: getApplyResponsibles(application),
  collaborators: getApplyCollaborators(application),
})

export default {
  validationSchema,
  mapPropsToValues,
  mapValuesToData: values => [...values.responsibles, ...values.collaborators]
}
